import { render, staticRenderFns } from "./ModalDetail.vue?vue&type=template&id=617ae57b&scoped=true&"
import script from "./ModalDetail.vue?vue&type=script&lang=js&"
export * from "./ModalDetail.vue?vue&type=script&lang=js&"
import style0 from "./ModalDetail.vue?vue&type=style&index=0&id=617ae57b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617ae57b",
  null
  
)

export default component.exports